import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ZimbabweDayCelebration = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg01.jpg" },
  { img: "/assets/img/SOL/event/event1_mg02.jpg" },
  { img: "/assets/img/SOL/event/event1_mg03.jpg" },
  { img: "/assets/img/SOL/event/event1_mg04.jpg" },
  { img: "/assets/img/SOL/event/event1_mg05.jpg" }, 
  
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Zimbabwe Day Celebration" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>Date: 18th April 2024</p>
          <p>Venue: MVN University Campus</p>
          <p>Organized by: MVN University International Students Cell</p>
          <p>Theme: Celebrating Unity in Diversity</p>

          <strong>Objective of the Event</strong>
          <ul>
            <li>To provide Zimbabwean students with a platform to celebrate their national identity.</li>
            <li>To promote cultural awareness and foster inclusivity among students from different backgrounds.</li>
            <li>To encourage cross-cultural interaction and understanding through various performances and activities.</li>
          </ul>
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ZimbabweDayCelebration;
